// extracted by mini-css-extract-plugin
export default {"card":"card--fSQ7x","media-wrapper":"media-wrapper--qx1xb","mediaWrapper":"media-wrapper--qx1xb","caption-wrapper":"caption-wrapper--F1xf1","captionWrapper":"caption-wrapper--F1xf1"};